function startNestedTutorial(step) {
    var event = new CustomEvent('onNestedTutorialStarted', {
        detail: {
            step: step
        }
    })
    window.dispatchEvent(event);
}